function applyBadges() {

    document.querySelectorAll('product-card').forEach(card => {

        /* ==========================================
           GALERIA
        ========================================== */

        const gallery =
            card.querySelector('[data-badges-ready]') ||
            card.querySelector('.card-gallery') ||
            card.querySelector('.custom-product-card-media');

        if (!gallery)
            return;

        /* ==========================================
           QUICK VARIANT
        ========================================== */

        const quickVariant =
            card.querySelector('.quick-variant') ||
            card.querySelector('.quick-variant-fallback');

        if (!quickVariant)
            return;

        /* ==========================================
           STATE
        ========================================== */

        const state =
            `${quickVariant.dataset.collections || ''}|` +
            `${quickVariant.dataset.price || ''}|` +
            `${quickVariant.dataset.comparePrice || ''}|` +
            `${quickVariant.dataset.stock || ''}`;

        if (card.dataset.badgesState === state)
            return;

        card.dataset.badgesState =
            state;

        /* ==========================================
           DADOS
        ========================================== */

        const collections =
            (quickVariant.dataset.collections || '')
                .toLowerCase()
                .split(',')
                .map(v => v.trim())
                .filter(Boolean);

        const stock =
            Number(
                quickVariant.dataset.stock
            ) || 0;

        const hasDiasOrigem =
            collections.includes(
                'dias-origem'
            );

        /* ==========================================
           WRAPPER
        ========================================== */

        let wrapper =
            gallery.querySelector(
                '.product-badges'
            );

        if (!wrapper) {

            wrapper =
                document.createElement(
                    'div'
                );

            wrapper.className =
                'product-badges product-badges--top-left';

            gallery.prepend(
                wrapper
            );
        }

        /* ==========================================
           REMOVE NOSSAS BADGES
        ========================================== */

        wrapper
            .querySelectorAll(
                '.na-custom-badge, .na-dias-origem-badge'
            )
            .forEach(
                el => el.remove()
            );

/* ==========================================
   ESGOTADO
========================================== */

const hasSoldOut =
    stock <= 0;
    

        /* ==========================================
           DIAS ORIGEM
           APARECE JUNTO COM ESGOTADO
        ========================================== */

        if (hasDiasOrigem) {

            const badge =
                document.createElement(
                    'div'
                );

            badge.className =
                'na-dias-origem-badge';

            wrapper.appendChild(
                badge
            );
        }

        /* ==========================================
           BADGE PRINCIPAL
        ========================================== */

        let customBadge =
            null;

        if (hasSoldOut)
            customBadge =
                'ESGOTADO';

        // else if (stock > 0 && stock <= 3)
        //     customBadge =
        //         'ÚLTIMAS UNIDADES';

        // else if (collections.includes('best-sellers'))
        //     customBadge =
        //         'BEST SELLER';

        // else if (collections.includes('reposicao'))
        //     customBadge =
        //         'REPOSIÇÃO';

        // else if (collections.includes('novidades'))
        //     customBadge =
        //         'NOVIDADE';

        if (!customBadge)
            return;

        const badge =
            document.createElement(
                'div'
            );

        badge.className =
            'product-badges__badge product-badges__badge--rectangle na-custom-badge';

        badge.textContent =
            customBadge;

        wrapper.appendChild(
            badge
        );

    });

}

window.applyBadges =
    applyBadges;

/* ==========================================
   OBSERVER
========================================== */

let raf =
    null;

const observer =
    new MutationObserver(
        mutations => {

            let shouldRun =
                false;

            for (
                const mutation
                of mutations
            ) {

                for (
                    const node
                    of mutation.addedNodes
                ) {

                    if (
                        !(
                            node instanceof
                            HTMLElement
                        )
                    )
                        continue;

                    if (
                        node.classList?.contains(
                            'na-custom-badge'
                        ) ||
                        node.classList?.contains(
                            'na-dias-origem-badge'
                        )
                    ) {
                        continue;
                    }

                    if (
                        node.matches?.(
                            'product-card'
                        ) ||
                        node.querySelector?.(
                            'product-card'
                        )
                    ) {
                        shouldRun =
                            true;

                        break;
                    }
                }

                if (shouldRun)
                    break;
            }

            if (
                !shouldRun ||
                raf
            )
                return;

            raf =
                requestAnimationFrame(
                    () => {

                        raf =
                            null;

                        applyBadges();

                    }
                );

        }
    );

observer.observe(
    document.body,
    {
        childList: true,
        subtree: true
    }
);

/* ==========================================
   PRIMEIRA EXECUÇÃO
========================================== */

applyBadges();